import { apiTokenService, AuthContext } from "@harvestr-api/common";

export const GITLAB_CLOUD_API_URL = "gitlab.com";

export async function getGitlabToken(ctx: AuthContext) {
    const tokens = await apiTokenService.getApiTokens(
        { where: { source: "GITLAB" } },
        ctx
    );
    return tokens.length
        ? { token: tokens[0]?.token, host_url: tokens[0].host_url }
        : undefined;
}

export async function getGitlabBearer(
    ctx: AuthContext,
    gotTokenAlready?: string,
    gotHostUrlAlready?: string
) {
    const tokenData = await getGitlabToken(ctx);
    let host_url = `${
        gotHostUrlAlready || tokenData?.host_url || GITLAB_CLOUD_API_URL
    }/api/v4`;
    host_url = host_url.includes("http") ? host_url : `https://${host_url}`;
    const token = !gotTokenAlready ? tokenData?.token : gotTokenAlready;

    if (token === undefined) {
        throw new Error("getGitlabBearer() : Not authorized");
    }
    return { auth: { bearer: token }, host_url };
}
